import { render, staticRenderFns } from "./ArticleComponent.vue?vue&type=template&id=c6e19ece&scoped=true&"
import script from "./ArticleComponent.vue?vue&type=script&lang=js&"
export * from "./ArticleComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleComponent.vue?vue&type=style&index=0&id=c6e19ece&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e19ece",
  null
  
)

export default component.exports